import { AfterViewInit, Component, effect, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { SharedService } from 'src/app/common/services/shared.service';
import { UnitTypeEnum } from '../../../models/unit-type-enum';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-warehouse-overview-rental-yield',
  templateUrl: './warehouse-overview-rental-yield.component.html',
  styleUrls: ['./warehouse-overview-rental-yield.component.scss']
})
export class WarehouseOverviewRentalYieldComponent implements OnChanges, OnInit {

    @Input() card_title: any;
    @Input() untillDate: any;
    @Input() uniType:any=null;
    @Input() graphData:any;
    @Input() propertiesCount: any = '';
    @Input() rentalsName: any = '';

    @Input() gradeWise: boolean = false;
    selected_category:any = null;
       developerDropdown = {
        label: 'reports.Select_type_of_property',
        data: [
        {
            value: 'dry_warehouse',
            id: 'dry_warehouse',
        },
        {
            value: 'ambient',
            id: 'ambient',
        },{
            value: 'cold_storage',
            id: 'cold_storage',
        },{
            value: 'frozen_warehouse',
            id: 'frozen_warehouse',
        }

      ],
        default: 'dry_warehouse',
        maxSelect: 1,
        reportType: false
    }

    symble:string='';
    lang: string = 'en';
    sortOrder: any = {
      grade_a_p: 1,
      grade_a: 2,
      grade_b: 3,
      grade_c: 4
    }
  
    averageRentRate = new Map();
    occupancyRate = new Map();
    UnitTypeEnum: any = UnitTypeEnum;
    constructor(
      private sharedService: SharedService,
      private translate: TranslateService,
      public reportService: ReportService,
      private decimalPipe: DecimalPipe
    ){
    }
    ngOnInit(){
      this.sharedService.language$.subscribe(lang => {
        this.lang = lang;
        this.symbleType();
      })
      if (this.gradeWise && this.graphData?.data?.length) {
        const labelMap: any = [
          'grade_a_p',
          'grade_a',
          'grade_b',
          'grade_c'
        ]
        this.graphData.data.forEach((item: any) => {
          if (labelMap.includes(item.grade)) {
            item['grade_o'] = item.grade;
          } else {
            item.grade = '-';
          }
        })
        this.selected_category = this.graphData?.data?.filter((item:any)=> item.warehouse_type ==this.developerDropdown.default)?.sort((a: any, b: any) => {
          const orderA = this.sortOrder[a.grade_o] ?? 99;
          const orderB = this.sortOrder[b.grade_o] ?? 99;
          return orderA - orderB;
        });
      }
    }
    
    ngOnChanges(changes: SimpleChanges) {
       
      if(this.propertiesCount) this.propertiesCount = this.decimalPipe?.transform((this.propertiesCount), '1.0-1');
      this.symbleType();
     
    }
  
    symbleType(){
      if(this.uniType == UnitTypeEnum.sqm){
        this.symble = this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)
      }
      if(this.uniType == UnitTypeEnum.percentage){
        this.symble = GlobalContants.keySymbolContants.percentage
      }
      if(this.uniType == UnitTypeEnum.currency){
        this.symble = this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode));
      }
      if(this.uniType == UnitTypeEnum.currencywithsqm){
        this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squareMeterUnit)}`;
      }
      if(this.uniType == UnitTypeEnum.currencywithsqrt){
        this.symble = ` ${this.translate.instant(this.sharedService.getStoreValue(GlobalContants.StoreKey.CurrencyCode))}/${this.translate.instant(GlobalContants.keySymbolContants.squarefeetUnit)}`;
      }
    }
  
    getNumber(nbr: any){
      return +nbr;
    }
    dropDownChange(event:any){
      const labelMap: any = [
          'grade_a_p',
          'grade_a',
          'grade_b',
          'grade_c'
        ]
        this.graphData.data.forEach((item: any) => {
          if (labelMap.includes(item.grade)) {
            item['grade_o'] = item.grade;
          } else {
            item.grade = '-';
          }
        })
      this.selected_category = this.graphData?.data?.filter((item:any)=> item.warehouse_type == event)?.sort((a: any, b: any) => {
          const orderA = this.sortOrder[a.grade_o] ?? 99;
          const orderB = this.sortOrder[b.grade_o] ?? 99;
          return orderA - orderB;
        });

    }

    
    ngOnDestroy() {
      
    }
}
